import Config from "@/common/config";
import { baseAxiosInstance } from "@/api/base";
import type { AxiosResponse } from "axios";
import type {
  FreightDetailRow,
  QuotationData,
} from "@/common/types/chargeWeight";

const routingEndpoint = Config.apiEndpoints.routings;
const transportsEndpoint = Config.apiEndpoints.transports;

/**
 * @summary Retrieves matching transports / routes
 */
async function getRoutings(
  data: Pick<
    QuotationData,
    Exclude<keyof QuotationData, "chargeWeight" | "additionalInformation">
  >,
): Promise<AxiosResponse> {
  return await baseAxiosInstance.post(routingEndpoint, data);
}
async function getTransports(
  data: Omit<QuotationData, "additionalInformation">,
): Promise<AxiosResponse> {
  const calculateHuSum = (freightDetailRows: FreightDetailRow[] = []) =>
    freightDetailRows.reduce((sum, row) => sum + (row.amount ?? 0), 0);

  const { freightDetailRows, ...chargeWeightRest } = data.chargeWeight;

  const payload = {
    ...data,
    chargeWeight: {
      ...chargeWeightRest,
      huSum: calculateHuSum(freightDetailRows),
    },
  };

  return baseAxiosInstance.post(transportsEndpoint, payload);
}

export const transportsAPI = {
  getTransports,
  getRoutings,
};
